export const COMMON = {
  GHG_EMISSION: "GHG Emission",
  EMISSION_FACTOR: "Emission Factor",
  ASSET_NAME: "Asset Name",
  TONCO2E: "tons CO₂e",
  KGCO2E: "kgCO₂e",
  NO_DATA: "No Data",
  ENERGY_SYSTEM: "Energy system",
  PARENT: "Parent",
  SUBSIDIARY: "Subsidiary",
  ADD_SUBSIDIARY: "Add Subsidiary",
  NO_SUBSIDIARY: "No Subsidiary",
  HQ: "HQ",
  YES: "Yes",
  NO: "No",
  NO_OPTIONS_FOUND: "No options found",
  SCOPE: "Scope",
  ACTIVITY: "Emission Activity",
  EMISSION_SOURCE: "Emission Source",
  UNIT: "Unit",
  NUMBER: "No.",
  ACTIVITY_DATA: "Activity Data",
  ACTIONS: "Actions",
  TOTAL: "Total",
  CANCEL: "Cancel",
  SAVE: "Save",
  DELETE: "Delete",
  COMPANY_NAME: "Company Name",
  ADDRESS: "Address",
  CREATE: "Create",
  UPDATE: "Update",
  ROLE: "Role",
  COMPANY: "Company",
  NEXT: "Next",
  PREVIOUS: "Previous",
  TARGET_YEAR: "Target Year",
  TCO2E: "tCO₂e",
  SCOPE1: "Scope 1",
  SCOPE2: "Scope 2",
  SCOPE3: "Scope 3",
  BASE_YEAR: "Base Year",
  ARE_U_SURE: "Are you sure you want to delete",
  ACTION: "Action",
  HEADER: "Company Emission<br />Reduction Strategy<br />Report",
  TABLE_OF_CONTENTS: "Table of Contents",
  COMPANY_NAME: "Company Name",
  COMPANY_ADDRESS: "Company Address",
  LOCATION: "Location",
  CITY: "City",
  COMPANY_TYPE: "Company Type",
  INDUSTRY_SECTOR: "Industry Sector",
  UNIFIED_BUSINESS_NO: "Unified Business No.",
  NUMBER_OF_EMPLOYEES: "Number of Employees",
  SPACE_USED: "Space Used (m²)",
  CONTRACT_CAPACITY: "Contract Capacity  (kW)",
  ANNUAL_REVENUE: "Annual Revenue (million USD)",
  SCOPE1_EMISSION_TCO2E: "Scope 1 Emissions (tCO₂e)",
  SCOPE2_EMISSION_TCO2E: "Scope 2 Emissions (tCO₂e)",
  SCOPE3_EMISSION_TCO2E: "Scope 3 Emissions (tCO₂e)",
  CARBON_EMISSION_PER_EMPLOYEE: "Carbon Emission per Employee (tCO₂e/Employee)",
  TCO2E_PER_EMPLOYEE: "Per Employee",
  CARBON_EMISSION_PER_REVENUE:
    "Carbon Emission per Revenue (tCO₂e/Revenue – {{millionCurrency}})",
  TCO2E_PER_REVENUE: "Per Revenue",
  SCOPE1: "Scope 1",
  SCOPE2: "Scope 2",
  SCOPE3: "Scope 3",
  CARBON_CONTRIBUTION: "Carbon Contribution",
  CONFIGURATION: "Configuration",
  AND: "and",
  TOTAL_EMISSION: "Total Emission",
  CONSUMPTION_DATA: "Consumption Data",
  CARBON_EMISSION_PER_GROSS_FLOOR_AREA:
    "Carbon Emission per Gross Floor Area (tCO₂e/m²)",
  SBTi: "SBTi (°C)",
  CONSUMPTION_DATA_KWH_OR_KG_Y: "Consumption Data",
  KWH_OR_KG_Y: "kWh or kg/y",
  KGCO2E_KWH_KG: "kg CO₂e/kWh or kg",
  TOTAl_REDUCTION_RATE: "Total Reduction Rate",
  TYPE: "Type",
  THERE_IS_NO_DATA: "There is no data.",
  BACK_TO_HOME: "Back to Homepage",
  SAVE_CHANGE_ONBOARD: "Save Change And Update Onboarding Information",
  ONBOARD_ALERT_MSG:
    "Do you want to save the changes and update Onboarding Information",
  DELETE_CONFIRMATION: "Delete Confirmation",
  EDIT: "Edit",
  TEMPLATE_NAME: "Template Name",
  COMPANY_LOGO: "Company Logo",
  CREATE_NEW_TEMPLATE: "Create New Template",
  DATE: "Date",
};

export const HQ = "hq";
export const SUBSIDIARY = "subsidiary";
